__webpack_require__.p = "/local/templates/new_index/frontend/build/";